import React from 'react'

export default ({
  ...props
}) => (
  <div className='list-search'>
    <input type='search' {...props} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/areas/area-work-tracker-search.js